module.exports = __webpack_public_path__ + "static/img/tx002.14f0e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx002.png
// module id = 626k
// module chunks = 1